import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Logofill from "../assets/img/logoFill_balck.svg";
import { useState } from "react";
// import EnterOtp from "./enterotp";
// import CreatePassword from "./createpassword";

import { useForm } from "react-hook-form";
import {
  otpValidateReset,
  resetPasswordReset,
  userForgotPassword,
  userOTPValidate,
  userResetPassword,
} from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formState, setFormState] = useState(0);
  const [email, setEmail] = useState(null);
  const [otp, setOtp] = useState(null);

  const auth = useSelector((state) => state.auth);

  const {
    register: forgotPasswordRegister,
    handleSubmit: forgotPasswordHandleSubmit,
    formState: { errors: forgotPasswordErrors },
  } = useForm();

  const {
    register: otpValidateRegister,
    handleSubmit: otpValidateHandleSubmit,
    formState: { errors: otpValidateErrors },
    watch: otpValidateWatch,
  } = useForm();

  const {
    register: resetPasswordRegister,
    handleSubmit: resetPasswordHandleSubmit,
    formState: { errors: resetPasswordErrors },
  } = useForm();

  const forgotPassword = (data) => {
    dispatch(
      userForgotPassword({
        email: data.email,
      })
    )
      .unwrap()
      .then((response) => {
        setEmail(data.email);
        setFormState(1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const otpValidate = (data) => {
    dispatch(
      userOTPValidate({
        email: email,
        otp: data.otp,
      })
    )
      .unwrap()
      .then((response) => {
        setEmail(email);
        setOtp(data.otp);
        setFormState(2);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resetPassword = (data) => {
    dispatch(
      userResetPassword({
        email: email,
        otp: otp,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
      })
    )
      .unwrap()
      .then((response) => {
        // console.log(response);
        navigate("/login");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="login-pg-container">
        {/* login content starts*/}
        <div className="center-container">
          <div className="center-container-box forgot-password-box forgot-password-container">
            {formState === 0 && (
              <div style={{ color: "#000000" }}>
                <div className="logo-login ">
                  <a href="/">
                    <img src={Logofill} />
                  </a>
                </div>
                {forgotPasswordErrors.email?.type === "required" && (
                  <div className="error-box show-error-box">
                    <p>Email field cannot be blank.</p>
                  </div>
                )}
                {forgotPasswordErrors.email?.type === "pattern" && (
                  <div className="error-box show-error-box">
                    <p>Please enter a valid email.</p>
                  </div>
                )}

                <div className="passwrod-info">
                  <h2>Reset Your Password</h2>
                  <h3>
                    Enter your email below and we'll send you <br />
                    an email to reset your password.
                  </h3>
                </div>
                <div className="login-form">
                  <form
                    onSubmit={forgotPasswordHandleSubmit(forgotPassword)}
                    method="post"
                  >
                    <div className="field-box">
                      <div className="formGroup">
                        {auth.forgotPasword.error &&
                          !forgotPasswordErrors.email && (
                            <div className="error-box">
                              <p>{auth.forgotPasword?.error?.error?.message}</p>
                            </div>
                          )}
                        <input
                          type="text"
                          className={`frmControl ${
                            forgotPasswordErrors.email ? "inputErr" : ""
                          }`}
                          placeholder="name@example.com"
                          {...forgotPasswordRegister("email", {
                            required: true,
                            pattern:
                              /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                          })}
                        />
                      </div>
                    </div>
                    <div className="btn-sec mb15">
                      <button className="btnSecondry-new btnBlock">
                        Send Reset Email
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {formState === 1 && (
              <div style={{ color: "#000000" }}>
                <div className="logo-login form-error-show">
                  <a href="/">
                    <img src={Logofill} />
                  </a>
                </div>
                {otpValidateErrors.otp?.type === "required" && (
                  <div className="error-box show-error-box">
                    <p>Otp field cannot be blank.</p>
                  </div>
                )}
                {otpValidateErrors.otp?.type === "minLength" && (
                  <div className="error-box show-error-box">
                    <p>Please enter a valid OTP (min 6 character)</p>
                  </div>
                )}
                {auth.otpValidate.error && !otpValidateErrors.otp && (
                  <div className="error-box show-error-box">
                    <p>{auth.otpValidate.error.error.message}</p>
                  </div>
                )}
                <div className="passwrod-info" style={{ maxWidth: "100%" }}>
                  <a href="#">
                    {/* <img src="../assets/img/done_icon.svg" class="center" /> */}
                  </a>
                  <h2>Enter Your One Time Password.</h2>
                  {/* <h2>Email Sent</h2> */}
                  <h3>Look for the one-time password in the</h3>
                  <h3>reset email we just sent you.</h3>
                </div>
                <div className="login-form">
                  <form
                    onSubmit={otpValidateHandleSubmit(otpValidate)}
                    method="post"
                  >
                    <div className="field-box">
                      <div className="formGroup">
                        <input
                          onKeyUp={() => dispatch(otpValidateReset())}
                          {...otpValidateRegister("otp", {
                            required: true,
                            minLength: 6,
                          })}
                          type="password"
                          className={`frmControl ${
                            otpValidateErrors.otp || auth.otpValidate.error
                              ? "inputErr"
                              : ""
                          }`}
                          placeholder="One Time Password"
                        />
                      </div>
                    </div>
                    <div className="btn-sec mb15">
                      <button className="btnSecondry-new btnBlock">
                        Continue
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {formState === 2 && (
              <div style={{ color: "#000000" }}>
                <div className="logo-login form-error-show">
                  <a href="/">
                    <img src={Logofill} />
                  </a>
                </div>
                {resetPasswordErrors.newPassword?.type === "required" && (
                  <div className="error-box show-error-box">
                    <p>Password field is required.</p>
                  </div>
                )}

                {resetPasswordErrors.newPassword?.type !== "required" &&
                  resetPasswordErrors.newPassword?.type === "minLength" && (
                    <div className="error-box show-error-box">
                      <p>Please enter a valid password (min 8 character)</p>
                    </div>
                  )}

                {auth.resetPassword.error &&
                  !resetPasswordErrors.newPassword && (
                    <div className="error-box show-error-box">
                      <p>{auth.resetPassword.error.error.message}</p>
                    </div>
                  )}

                <div className="passwrod-info">
                  <h2>Create a New Password</h2>

                  <h3 className="creat-new-password-pad">
                    <div>Please enter a new password</div>
                    <div>for your Abound profile.</div>
                  </h3>
                </div>
                <div className="login-form">
                  <form
                    onSubmit={resetPasswordHandleSubmit(resetPassword)}
                    method="post"
                  >
                    <div className="field-box">
                      <div className="formGroup">
                        <input
                          onKeyUp={() => dispatch(resetPasswordReset())}
                          {...resetPasswordRegister("newPassword", {
                            required: true,
                            minLength: 8,
                          })}
                          className={`frmControl ${
                            resetPasswordErrors.newPassword ? "inputErr" : ""
                          }`}
                          type="password"
                          placeholder="New Password"
                        />
                      </div>
                    </div>
                    {/* <div className="field-box">
                      <div className="formGroup">
                        <input
                          {...resetPasswordRegister("confirmPassword", {
                            required: true,
                            minLength: 8,
                          })}
                          className={`frmControl ${
                            resetPasswordErrors.confirmPassword
                              ? "inputErr"
                              : ""
                          }`}
                          type="password"
                          placeholder="Confirm Password"
                        />
                      </div>
                    </div> */}
                    <div className="btn-sec mb15">
                      <button className="btnSecondry-new btnBlock">
                        Save &amp; Log In
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
